import type { CanvasDocumentState } from './documentModel';
import { CommandRegistry, createMoveOperation } from './commandRegistry';
import type { DragDraft } from './gesture';
import { beginDrag, cancelDrag, commitDrag, updateDragFromScreenDelta } from './gesture';

export function commitDragGesture(
  registry: CommandRegistry,
  document: CanvasDocumentState,
  draft: DragDraft,
): { document: CanvasDocumentState; registry: CommandRegistry } | null {
  const after = commitDrag(draft);
  if (!after) {
    return null;
  }

  const before: Record<string, { x: number; y: number }> = {};
  for (const elementId of draft.elementIds) {
    const start = draft.startPositions[elementId];
    if (start) {
      before[elementId] = { ...start };
    }
  }

  const operation = createMoveOperation(draft.elementIds, before, after);
  const nextDocument = registry.commit(document, operation);
  return { document: nextDocument, registry };
}

/** Pointer moves update draft only — no history entry until commit. */
export function previewDragWithoutHistory(
  registry: CommandRegistry,
  draft: DragDraft,
  screenDelta: { x: number; y: number },
  zoom: number,
): DragDraft {
  void registry;
  return updateDragFromScreenDelta(draft, screenDelta, zoom);
}

export { beginDrag, cancelDrag, commitDrag };
